export default {
  API_ENDPOINT: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000"
};
